//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "QuizGridView",
  created() {},
  props: ["question"],
  data() {
    return {
      selectedCharacters: []
    };
  },
  computed: {
    answer: function() {
      return this.selectedCharacters.join("");
    }
  },
  methods: {
    toggleCharacter: function(character) {
      let index = this.selectedCharacters.indexOf(character);

      if (index >= 0) {
        this.selectedCharacters.splice(index, 1);
      } else {
        this.selectedCharacters.push(character);
      }
    },

    submit: function() {
      let answer = (this.answer || "").trim();

      if (answer == "") {
        this.$vux.toast.text("答案不能为空", "middle");
        return;
      }

      this.$emit("answer", answer);
    }
  },
  watch: {
    question: function() {
      this.selectedCharacters = [];
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/quiz/quiz_question/QuizGridView.vue